import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Pencil, Check, X } from 'lucide-react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

const MAX_NAME_LENGTH = 50;

export const AnalysisNameEditor = ({
    isEditing,
    analysisName,
    tempName,
    startEditing,
    saveEdit,
    cancelEdit,
    handleKeyPress,
    setTempName,
    inputRef
}) => {
    if (isEditing) {
        return (
            <div className="flex items-center gap-2">
                <div className="relative flex items-center gap-2">
                    <span className="text-sm text-gray-600 font-semibold whitespace-nowrap">Name:</span>
                    <div className="relative">
                        <Input
                            ref={inputRef}
                            type="text"
                            id="analysis-name"
                            name="analysis-name"
                            value={tempName}
                            onChange={(e) => setTempName(e.target.value)}
                            onKeyDown={handleKeyPress}
                            className="text-center w-64 h-8 border-gray-200 hover:border-gray-300 focus-visible:ring-0 focus-visible:ring-offset-0 bg-white/50 pr-16"
                            onClick={(e) => e.preventDefault()}
                            placeholder="Enter analysis name"
                            maxLength={MAX_NAME_LENGTH}
                        />
                        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">
                            {tempName.length}/{MAX_NAME_LENGTH}
                        </span>
                    </div>
                </div>
                <EditorButtons onSave={saveEdit} onCancel={cancelEdit} />
            </div>
        );
    }

    return (
        <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600 font-semibold">Name:</span>
            <p className="text-sm text-gray-400 max-w-[200px] truncate font-medium">
                {analysisName}
            </p>
            <TooltipProvider delayDuration={150}>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            size="icon"
                            variant="ghost"
                            className="h-8 w-8 hover:bg-green-50 transition-colors"
                            onClick={(e) => {
                                e.preventDefault();
                                startEditing();
                            }}
                        >
                            <Pencil className="h-4 w-4 text-gray-400" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>Edit analysis name</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
};

const EditorButtons = ({ onSave, onCancel }) => (
    <div className="flex gap-1" onClick={(e) => e.preventDefault()}>
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        size="icon"
                        variant="ghost"
                        className="h-8 w-8 hover:bg-green-100 transition-colors"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onSave();
                        }}
                        type="button"
                    >
                        <Check className="h-4 w-4 text-gray-400" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Save name</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>

        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        size="icon"
                        variant="ghost"
                        className="h-8 w-8 hover:bg-red-100 transition-colors"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onCancel();
                        }}
                        type="button"
                    >
                        <X className="h-4 w-4 text-gray-400" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Cancel editing</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    </div>
);